import { $getLocalStorage } from '@/assets/common/common';
import { get } from 'lodash';
import { VueCookieNext } from 'vue-cookie-next';
import { createRouter, createWebHistory } from 'vue-router';
import info from './info';
const routes = [
	{
		path: '',
		name: 'Layout',
		component: () => import( '@/views/index.vue' ),
		children: [
			{
				path: '',
				name: 'page',
				redirect: '/home',
				component: () => import( '@/views/home/home.vue' ),
				children: [
					{
						path: '/home',
						name: 'Home',
						component: () => import( '@/views/home/index.vue' ),
					},
					{
						path: '/dentalHomePage',
						name: 'Dental',
						component: () => import( '@/views/dental/index.vue' ),
					},
				],
			},
			// 资源中心
			{
				path: '/resourceCenter',
				name: 'Resource',
				redirect: '/resourceCenter/apps',
				component: () => import( '@/layout/otherLayout.vue' ),
				children: [
					{
						path: '/resourceCenter/apps',
						name: 'Apps',
						component: () => import( '@/views/resource-center/index.vue' ),
					},
				],
			},
			// 收费标准
			{
				path: '/charge/index',
				name: 'charge',
				component: () => import( '@/views/charge/index.vue' ),
			},
			// 控制台
			{
				path: '/console',
				name: 'Console',
				meta: { login: true },
				redirect: '/console/theConsole',
				component: () => import( '@/views/console/index.vue' ),
				children: [
					{
						path: '/console/ticket',
						name: 'Ticket',
						meta: { attribution: 'Ticket' },
						component: () => import( '@/views/console/ticket/index.vue' ),
					},
					{
						path: '/console/ticket/:id',
						name: 'ticketDetail',
						meta: {
							attribution: 'Ticket',
							breadcrumb: ['Ticket', 'ticketDetail'],
						},
						component: () => import( '@/views/tickets/detail.vue' ),
					},
					{
						path: '/console/institutions',
						name: 'Institutions',
						meta: { attribution: 'Institutions' },
						component: () => import( '@/views/console/uniqueness/index.vue' ),
					},
					{
						path: '/console/institutions/agementAccount',
						name: 'agementAccount',
						meta: {
							attribution: 'Institutions',
							breadcrumb: ['Institutions', 'InstitutionsManage'],
						},
						component: () => import( '@/views/console/uniqueness/agementAccount.vue' ),
					},
					{
						path: '/console/application',
						name: 'Application',
						meta: { attribution: 'Application' },
						component: () => import( '@/views/console/application/index.vue' ),
					},
					{
						path: '/console/application/:id',
						name: 'ApplicationDetails',
						meta: {
							attribution: 'Application',
							breadcrumb: ['Application', 'ApplicationDetails'],
						},
						component: () => import( '@/views/console/application/details.vue' ),
					},
					{
						path: '/console/basicInfoDetails',
						name: 'basicInfoDetails',
						meta: {
							attribution: 'Application',
							breadcrumb: ['Application', 'basicInfoDetails'],
						},
						component: () => import( '@/views/console/application/basicInfoDetails.vue' ),
					},
					{
						path: '/console/theConsole',
						name: 'TheConsole',
						meta: { attribution: 'TheConsole' },
						component: () => import( '@/views/console/theConsole/index.vue' ),
					},
				],
			},
			// 个人中心
			{
				path: '/user',
				name: 'User',
				redirect: '/info',
				component: () => import( '@/views/user/index.vue' ),
				children: info,
			},
		],
	},
	{
		path: '/3dViewer',
		name: '3dViewer',
		component: () => import( '@/views/3dViewer/index.vue' ),
	},
	{
		path: '/3dViewer-h5',
		name: '3dViewerH5',
		component: () => import( '@/views/3dViewer/index.vue' ),
	},
	{
		path: '/',
		name: 'user',
		component: () => import( '@/views/user/layout.vue' ),
		children: [
			{
				path: '/login',
				name: 'Login',
				component: () => import( '@/views/login/login.vue' ),
			},
			{
				path: '/perfectInfo',
				name: 'perfectInfo',
				component: () => import( '@/views/user/perfectInfo.vue' ),
			},
			{
				path: '/signup',
				name: 'Signup',
				component: () => import( '@/views/user/signup.vue' ),
			},
			{
				path: '/sisu',
				name: 'SignupSuccess',
				component: () => import( '@/views/user/signupsuccess.vue' ),
			},
			{
				path: '/repd',
				name: 'Repd',
				component: () => import( '@/views/user/findpwd.vue' ),
			},
			{
				path: 'mfaValidate',
				name: 'mfaValidate',
				component: () => import( '@/views/user/mfa.vue' ),
				meta: { login: true }
			}
		],
	},
];

const router = createRouter({
	history: createWebHistory( '/' ),
	routes,
});

// const store = useStore();
const handleInstitutionsTo = ( to ) => {
	const org = $getLocalStorage( 'currentOrganization' );
	const isOrgAdmin = org?.isAdmin === 'y';
	if ( to.name === 'Institutions' && to.query.type === 'add' ) {
		return true;
	} else if (
		( to.name === 'Institutions' || to.name === 'agementAccount' ) &&
		!isOrgAdmin
	) {
		// 如果跳转机构资质菜单且并不是机构管理员，如果当前机构为空说明名下无机构可以跳转
		return false;
	} else {
		return true;
	}
};

router.beforeEach(( to, from, next ) => {
	const org = $getLocalStorage( 'currentOrganization' );
	let title = get( window, 'app.i18n.@shining3d/app.title' ) || '';
	document.title = title;
	const needLogin = to.matched.some(( item ) => item.meta?.login );

	const token = VueCookieNext.getCookie( 'token' );
	if ( to.name === 'mfaValidate' && from.name === 'Login' ){
		// 如果要跳到MFA验证页面则必须来自登录页
		next();
	} else if ( needLogin && !token ) {
		// 如果目标路由需要登陆且没有登陆  跳转首页
		router.push( 'home' );
	}
	// 是否是开放平台的机构成员
	const isOpenMember = org?.isOpenMember === 'y';
	if (( to.name === 'Ticket' || to.name === 'ticketDetail' ) && !isOpenMember ) {
		router.go( -1 );
	}
	// 机构拦截
	if ( !handleInstitutionsTo( to )) {
		// router.go( -1 );
		router.push( '/console/TheConsole' );
	}
	next();
});
export default router;
